module.exports = __webpack_public_path__ + "img/no-data_item.05f3d8b0.svg";